import type { HpUserInteraction } from '@zg-rentals/ts-hotpads-api-client';

export type InteractionName = `${HpUserInteraction}`;

const INTERACTION_NAMES: Record<InteractionName, true> = {
  favorite: true,
  hide: true,
  inquiry: true,
  share: true,
  tour: true,
  view: true,
};

// The V2 listing endpoints name three interactions differently from V3.
const V3_NAME_BY_V2_NAME = new Map<string, InteractionName>([
  ['viewed', 'view'],
  ['hidden', 'hide'],
  ['shared', 'share'],
]);

const isInteractionName = (name: string): name is InteractionName => Object.hasOwn(INTERACTION_NAMES, name);

export function userItemTypesFromInteractions(
  interactions: Array<{ type?: InteractionName } | null | undefined> | null | undefined,
): Array<InteractionName> {
  return Array.from(
    new Set((interactions ?? []).map((interaction) => interaction?.type).filter((type): type is InteractionName => Boolean(type))),
  );
}

export function userItemTypesFromV2(types: Array<string> | null | undefined): Array<InteractionName> {
  return Array.from(new Set((types ?? []).map((type) => V3_NAME_BY_V2_NAME.get(type) ?? type).filter(isInteractionName)));
}

export function latestInteractionDate(
  interactions: Array<{ type?: InteractionName; created?: number } | null | undefined> | null | undefined,
  name: InteractionName,
): number {
  return Math.max(
    0,
    ...(interactions ?? []).flatMap((interaction) => (interaction?.type === name && interaction.created ? [interaction.created] : [])),
  );
}
